export type FontSize = "S" | "M" | "L";

const FONT_SIZE_KEY = "boort:font-size";

export function getFontSize(): FontSize {
  try {
    const v = localStorage.getItem(FONT_SIZE_KEY);
    if (v === "S" || v === "M" || v === "L") return v;
  } catch {
    // localStorage unavailable (private mode, etc.) — fall through to default.
  }
  return "M";
}

export function setFontSize(size: FontSize): void {
  try {
    localStorage.setItem(FONT_SIZE_KEY, size);
  } catch {
    // ignore
  }
}

function scrollKey(bookId: string): string {
  return `boort:scroll:${bookId}`;
}

export function getScrollPos(bookId: string): number | null {
  try {
    const v = localStorage.getItem(scrollKey(bookId));
    return v != null ? Number(v) : null;
  } catch {
    return null;
  }
}

export function setScrollPos(bookId: string, pos: number): void {
  try {
    localStorage.setItem(scrollKey(bookId), String(Math.round(pos)));
  } catch {
    // ignore
  }
}

export type BookTab = "book" | "summary";

function tabKey(bookId: string): string {
  return `boort:tab:${bookId}`;
}

/** Which of the Book/Summary tabs a book's detail view was last showing, per book. */
export function getBookTab(bookId: string): BookTab {
  try {
    const v = localStorage.getItem(tabKey(bookId));
    if (v === "book" || v === "summary") return v;
  } catch {
    // localStorage unavailable (private mode, etc.) — fall through to default.
  }
  return "book";
}

export function setBookTab(bookId: string, tab: BookTab): void {
  try {
    localStorage.setItem(tabKey(bookId), tab);
  } catch {
    // ignore
  }
}
